
























import { Component, Prop, Vue } from 'vue-property-decorator';
import { Notification as INotification } from '@/store/modules/notifications';
import { State, namespace } from 'vuex-class';

interface PositionStyle {
  top?: string,
  bottom?: string,
}

const NotificationsNS = namespace('notifications');

@Component
export default class Notification extends Vue {

  @Prop({ type: String, default: '' }) protected message!: string;
  @Prop({ type: String, default: '' }) protected icon!: string;
  @Prop({ type: String, default: 'top' }) protected verticalAlign!: string;
  @Prop({ type: String, default: 'center' }) protected horizontalAlign!: string;
  @Prop({ type: String, default: 'info' }) protected type!: string;
  @Prop({ type: Number, default: 2500 }) protected timeout!: number;
  @Prop({ type: Date,   default: new Date() }) protected timestamp!: Date;

  protected elmHeight: number = 0;

  @NotificationsNS.State('display') protected notificationsList: any;

  protected get hasIcon() {
    return this.icon && this.icon.length > 0;
  }

  protected get alertType() {
    return `alert-${this.type}`;
  }

  protected get customPosition(): PositionStyle {

    let initialMargin = 20;
    let alertHeight = this.elmHeight + 10;

    let sameAlertsCount = this.notificationsList.filter((n: INotification) => {
      return (
        n.horizontalAlign === this.horizontalAlign &&
        n.verticalAlign === this.verticalAlign &&
        n.timestamp <= this.timestamp
      );
    }).length;

    let pixels: number = (sameAlertsCount - 1) * alertHeight + initialMargin;
    let styles: PositionStyle = {};

    if (this.verticalAlign === 'top')
      styles.top = `${pixels}px`;
    else
      styles.bottom = `${pixels}px`;

    return styles;

  }

  protected close() {
    this.$emit('on-close', this.timestamp);
  }

  protected mounted() {
    this.elmHeight = this.$el.clientHeight;
    if (this.timeout) {
      setTimeout(this.close, this.timeout);
    }
  }

}

